export default {
  employees: "Кассирҳо",
  noCreatedYet: "Ҳоло ягон кассир эҷод нашудааст",
  downloadAppRCKassa: "Барномаи RC KASSA-ро боргирӣ кунед",
  downloadRCKassa: "RC KASSA-ро боргирӣ кунед",
  addingEmployee: "Иловаи кассир",
  toCreateEmployeeNeedPoint:
    "Барои эҷоди кассир ақаллан як нуқтаи савдо лозим аст",
  secondName: "Насаб (фамилия) кассир",
  firstName: "Номи кассир",
  toTradingPoints: "Ба нуқтаҳои савдо",
  uWantToDeleteEmployee: "Шумо мутмаин ҳастед, ки мехоҳед кассирро нест кунед?",
  personName: "Насаб ва Ном",
  blockAccess: "Дастрасиро маҳкам кардан",
  openAccess: "Дастрасиро кушодан",

  employeeScore: "Холҳо барои кассирҳо",
  points: "хол",
  debiting: "Хориҷкунӣ",
  accrual: "Ҳисобкунӣ",
};
